import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseModalProps,
} from '@chakra-ui/react'
import React from 'react'
import { NextStepFragment } from '@gql'
import { useTranslation } from 'react-i18next'
import NextStepContent from '../components/NextStepContent'

interface Props extends UseModalProps {
  scopeCircleId: string
  meetingId?: string
  threadId?: string
  nextStep?: NextStepFragment
  onCreate?(nextStepId: string): void | Promise<unknown>
}

export default function NextStepModal({
  scopeCircleId,
  meetingId,
  threadId,
  nextStep,
  onCreate,
  ...modalProps
}: Props) {
  const { t } = useTranslation()

  return (
    <Modal size="lg" {...modalProps}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t(nextStep ? 'NextStepModal.headingEdit' : 'NextStepModal.heading')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <NextStepContent
            // Same layout as inside a tension: role and member side by side.
            // One form, one look, wherever a step is written.
            compact
            scopeCircleId={scopeCircleId}
            meetingId={meetingId}
            threadId={threadId}
            nextStep={nextStep}
            onClose={modalProps.onClose}
            onCreate={onCreate}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
